<template>
    <div class="index_right_padding">
        <div class="cockpitBox" style="margin-top:16px">
            <div class="cockpit_header">
                <div class="cockpit_header_bg">
                    <div><img :src="require('@/assets/img/cockpit/deng.png')" alt=""></div>
                    <div class="header_title">项目备案数量</div>
                    <div><img :src="require('@/assets/img/cockpit/dian.png')" alt=""></div>
                </div>
            </div>
            <div class="cockpit_content warning_box2" style="display:flex;align-item:center;justify-content: center;position: relative;">
                <div class="numBar_box numBar_box_left">
                    <div class="numBar_box_row" :style="{'background':'linear-gradient(90deg, rgba(253, 241, 86, 0) 0%,rgba('+rgbaFn(color[5])+',0.3) 100%)',borderColor:color[5]}">
                        <div>漯河</div>
                        <div>
                            00% | 5 条
                        </div>
                    </div>
                    <div class="numBar_box_row" :style="{'background':'linear-gradient(90deg, rgba(253, 241, 86, 0) 0%,rgba('+rgbaFn(color[4])+',0.3) 100%)',borderColor:color[4]}">
                        <div>漯河</div>
                        <div>
                            00% | 5 条
                        </div>
                    </div>
                    <div class="numBar_box_row" :style="{'background':'linear-gradient(90deg, rgba(253, 241, 86, 0) 0%,rgba('+rgbaFn(color[3])+',0.3) 100%)',borderColor:color[3]}">
                        <div>漯河</div>
                        <div>
                            00% | 5 条
                        </div>
                    </div>
                </div>
                <div id="numBar1"></div>
                <div class="numBar_box numBar_box_right">
                    <div class="numBar_box_row" :style="{'background':'linear-gradient(270deg, rgba(253, 241, 86, 0) 0%,rgba('+rgbaFn(color[0])+',0.3) 100%)',borderColor:color[0]}">
                        <div>漯河</div>
                        <div>
                            00% | 5 条
                        </div>
                    </div>
                    <div class="numBar_box_row" :style="{'background':'linear-gradient(270deg, rgba(253, 241, 86, 0) 0%,rgba('+rgbaFn(color[1])+',0.3) 100%)',borderColor:color[1]}">
                        <div>漯河</div>
                        <div>
                            00% | 5 条
                        </div>
                    </div>
                    <div class="numBar_box_row" :style="{'background':'linear-gradient(270deg, rgba(253, 241, 86, 0) 0%,rgba('+rgbaFn(color[2])+',0.3) 100%)',borderColor:color[2]}">
                        <div>漯河</div>
                        <div>
                            00% | 5 条
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cockpitBox" style="margin-top:38px">
            <div class="cockpit_header">
                <div class="cockpit_header_bg">
                    <div><img :src="require('@/assets/img/cockpit/deng.png')" alt=""></div>
                    <div class="header_title">项目预警数量</div>
                    <div><img :src="require('@/assets/img/cockpit/dian.png')" alt=""></div>
                </div>
            </div>
            <div class="cockpit_content warning_box2">
                <div id="numBar2"></div>
            </div>
            <div class="index_right_padding_warn_box">
                <div class="index_right_padding_warn">
                    <img :src="require('@/assets/img/cockpit/intelligence/red.png')" alt="">
                    <div class="right_padding_warn_dec">
                        <div>20</div>
                        <div>红色预警</div>
                        <div>50%</div>
                    </div>
                </div>
                <div class="index_right_padding_warn">
                    <img :src="require('@/assets/img/cockpit/intelligence/orange.png')" alt="">
                    <div class="right_padding_warn_dec">
                        <div>5</div>
                        <div>橙色预警</div>
                        <div>25%</div>
                    </div>
                </div>
                <div class="index_right_padding_warn">
                    <img :src="require('@/assets/img/cockpit/intelligence/yellow.png')" alt="">
                    <div class="right_padding_warn_dec">
                        <div>5</div>
                        <div>黄色预警</div>
                        <div>25%</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cockpitBox" style="margin-top:30px">
            <div class="cockpit_header">
                <div class="cockpit_header_bg">
                    <div><img :src="require('@/assets/img/cockpit/deng.png')" alt=""></div>
                    <div class="header_title">近30日中标单位</div>
                    <div><img :src="require('@/assets/img/cockpit/dian.png')" alt=""></div>
                </div>
            </div>
            <div class="cockpit_content warning_box2 tableBox">
                <el-table
                    :data="tableData"
                    stripe
                    style="width: 100%">
                    <el-table-column
                        prop="businessName"
                        label="序号"
                         align="left"
                         type="index"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="businessName"
                        label="项目名称"
                         align="left"
                        >
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.businessName" placement="right">
                                    <div class="businessName" >
                                        {{scope.row.businessName}}
                                    </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="flowName"
                        label="中标人"
                        align="left">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.value" placement="right">
                                    <div class="businessName" >
                                        {{scope.row.value}}
                                    </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from "echarts/core";
import { BarChart,ScatterChart,PieChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  DatasetComponentOption,
  TransformComponent,
  PolarComponent,
  LegendComponent
} from 'echarts/components';
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';
// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  PieChart,
  ScatterChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  PolarComponent,
  LegendComponent
]);
export default {
    data(){
        return{
            tableData:[
                {
                    businessName:'公司名称公司名称公司名称公司名称公司名称公司名称公司名称公...',
                    value:'公司名称公司名称公司名称公司名称公司名称公司名称公司名称公...'
                },
                {
                    businessName:'公司名称公司名称公司名称公司名称公司名称公司名称公司名称公...',
                    value:'公司名称公司名称公司名称公司名称公司名称公司名称公司名称公...'
                },
                {
                    businessName:'公司名称公司名称公司名称公司名称公司名称公司名称公司名称公...',
                    value:'公司名称公司名称公司名称公司名称公司名称公司名称公司名称公...'
                },
                {
                    businessName:'公司名称公司名称公司名称公司名称公司名称公司名称公司名称公...',
                    value:'公司名称公司名称公司名称公司名称公司名称公司名称公司名称公...'
                }
            ],
            color:['#BAFF7F','#FDF156','#2A8BFD','#FFB639','#8CEBFE','#13BFA3']
        }
    },
    mounted(){
        this.getBarData()
        this.getPieData()
    },
    methods:{
        getBarData(arr,arr2,name){//条形图
            var arr=[20,12,5,4,2];
            var arr2=[20-1,12-2,5-1,3,2];
            var total=0
            for(var i  in arr){
                total+=arr[i]
            }
            var name=['参数流程预警','代理业务能力预警','项目服务效能预警','交易主体活动轨迹预警','其他预警']
            var myChart=document.getElementById('numBar2')
            let seriesArr = [];
            seriesArr.push({
                type: 'bar',
                barWidth: '1',
                itemStyle: {
                    normal: {
                        color:'#fff',
                    }
                },
                label: {
                        show: true,
                        formatter: "{a|}",
                        position: "top",
                        distance: -10,
                        backgroundColor: "#B8DAFF",
                        shadowColor: "#B8DAFF",
                        shadowBlur: 10,
                        padding: 4,
                        borderRadius: 8,
                        rich: {
                            a: {
                                width: 3,
                                height: 3,
                                borderRadius: 6,
                                lineHeight: 3,
                                backgroundColor: "#B8DAFF"
                            }
                        }
                    },
                data: arr2,
                zlevel: 2
            })
            seriesArr.push({
                name: '',
                type: 'bar',
                barWidth:50,
                barGap: '-60%',
                data: arr,
                label: {
                    normal: {
                        show: true,
                        position: 'top',
                        fontSize: 13,
                        formatter: function(param) {
                            return `${param.value}条`;
                        },
                        color: '#fff',
                        opacity:0.8,
                        offset: [0, -10],
                    },
                },
                itemStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                            offset: 0,
                            color: 'rgba(24, 144, 255, 0.3) ' // 0% 处的颜色
                        }, {
                            offset: 1,
                            color: 'rgba(24, 144, 255, 0)' // 100% 处的颜色
                        }], false),
                        
                    borderColor:"rgba(24, 144, 255, 0.25)"
                    }
                },
                zlevel: 9,
                xAxisIndex: 1,
            })
            seriesArr.push({
                name: '',
                type: 'bar',
                barWidth:0,
                data: [0,0,0,0,0,0],
                label: {
                    show: true,
                    position: 'insideBottom',
                    distance: 15,
                    fontSize: 14,
                    color: '#FFFFFF',
                    opacity:0.7,
                    formatter: function(param) {
                        return `${((arr[param.dataIndex]/total)*100).toFixed(2)}%`;
                    },
                },
                itemStyle: {
                },
                xAxisIndex: 2,
                zlevel: 10,
            })
            var option = {
                grid: {
                    containLabel: true,
                    left: 20,
                    top: 40,
                    right: 30,
                    bottom: 10
                },
                xAxis: [{
                    type: 'category',
                    data: name,
                    axisLine: {
                        show: true,
                    },
                    axisLabel: {
                        show: true,
                        margin:10,
                        color: '#FFFFFF',
                        fontSize:13,
                        interval:0,
                        lineHeight:18,
                        opacity:0.7,
                         formatter: function (params) {
                            var newParamsName = "";
                            var paramsNameNumber = params.length;
                            var provideNumber = 5; // 一行显示几个字 然后就超过字数就会自动换行
                            var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                            if (paramsNameNumber > provideNumber) {
                            for (var p = 0; p < rowNumber; p++) {
                                var tempStr = "";
                                var start = p * provideNumber;
                                var end = start + provideNumber;
                                if (p == rowNumber - 1) {
                                tempStr = params.substring(start, paramsNameNumber);
                                } else {
                                tempStr = params.substring(start, end) + "\n";
                                }
                                newParamsName += tempStr;
                            }
                            } else {
                            newParamsName = params;
                            }
                            return newParamsName;
                        },
                    
                    },
                    axisTick: {
                        show: true
                    },
                    
                },{
                    type: 'category',
                    data: name,
                    axisLine: {show:false},
                    axisLabel: {
                        show: false,
                    },
                    axisTick: {
                        show: false
                    },
                    boundaryGap:true,
                    
                },{
                    type: 'category',
                    data: name,
                    axisLine: {show:false},
                    axisLabel: {
                        show: false,
                    },
                    axisTick: {
                        show: false
                    },
                    boundaryGap:true,
                    
                }],
                yAxis: [{
                        type: 'value',
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                    
                        axisLine: {
                            show: false
                        },
                        axisLabel: {
                            show: false
                            
                        },
                    },
                
                ],
                series:seriesArr
            };
            let chartBox = echarts.init(myChart);
            chartBox.setOption(option)
            window.addEventListener('resize', () => {
                chartBox.resize()
            })
        },
        getPieData(){
            var myChart=document.getElementById('numBar1')
            var color= this.color;
            var option = {
                color: ['#BAFF7F','#FDF156','#2A8BFD','#FFB639','#8CEBFE','#13BFA3'],
                //圆的背景颜色线
                polar: {
                    center: ['50%', '50%'],
                    radius: ["0%", "95%"],
                },
                angleAxis: {
                    interval: 1,
                    type: 'category',
                    data: [],
                    z: 10,
                    axisLine: {
                        show: false,
                    },
                },
                radiusAxis: {
                    min: 20,
                    max: 120,
                    interval: 20,
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        show:false,
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#0B4A6B",
                            width: 1,
                            type: "solid"
                        }
                    },
                    axisTick:{
                        show:false
                    }
                },
                calculable: true,
                series: [
                {
                    //外面透明的圆
                    type: 'pie',
                    radius: ["0%", "95%"],
                    center: ['50%', '50%'],
                    hoverAnimation: false,
                    labelLine: {
                        normal: {
                            show: false,
                        },
                        emphasis: {
                            show: false
                        }
                    },
                    name: "",
                    data: [{
                        name: '',
                        value: 0,
                        itemStyle: {
                            normal: {
                                color: "rgba(60, 189, 252, 0)"
                            }
                        }
                    }]
                }, {
                    stack: 'a',
                    type: 'pie',
                    radius: ['0%', '95%'],
                    center: ['50%', '50%'],
                    roseType: 'area',
                    zlevel: 10,
                    minAngle: 15,//最小角度
                    startAngle:100, //起始角度
                    label: {
                        normal: {
                            show:false
                        }
                    },
                    labelLine: {
                        normal: {
                            show: false,
                        },
                        emphasis: {
                            show: false
                        }
                    },
                    data: [
                        {
                            value: 5,
                            name: '数据1'
                        },
                        {
                            value: 15,
                            name: '数据2'
                        },
                        {
                            value: 25,
                            name: '数据3'
                        },
                        {
                            value: 20,
                            name: '数据4'
                        },
                        {
                            value: 35,
                            name: '数据5'
                        },
                        {
                            value: 35,
                            name: '数据6'
                        },
                    ]
                }, ]
            };
            // var option = {
            //         angleAxis: {
            //             show:false,
            //         },
            //         radiusAxis: {
            //             axisLine:{
            //             show:false
            //             },
            //             axisLabel:{
            //             show:false
            //             },
            //             axisTick:{
            //             show:false
            //             },
            //             splitLine: {
            //             show: true,
            //             lineStyle:{
            //                 color:'rgba(24, 144, 255, 0.25)'
            //             }
            //             },
            //         },
            //         polar: {
            //             show:false
            //         },
            //         series: [
            //             {
            //             type: 'bar',
            //             data: [1, 2, 3, 4, 3, 5, 1],
            //             coordinateSystem: 'polar',
            //             itemStyle:{
            //                 color:function(pa){
            //                 console.log(pa)
            //                 return color[pa.dataIndex]
            //                 },
            //             },
            //             },
            //         ],
            // };
            let chartBox = echarts.init(myChart);
            chartBox.setOption(option)
            window.addEventListener('resize', () => {
                chartBox.resize()
            })
        }
    }
}
</script>
<style lang="scss" scoped>

    .el-table__body-wrapper::-webkit-scrollbar {
        width:7px;
        background-color: transparent;
    }
    /* 滚动槽 */
    .el-table__body-wrapper::-webkit-scrollbar-track {
        -webkit-box-shadow:inset 2px rgba(0,0,0,0.3);
        background: #16335a;
    }
    /* 滚动条滑块 */
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background:#162b4b;
    }

    #numBar2{
        height: 182px;
        margin: 24px 0;
    }
    #numBar1{
        height: 191px;
        width: 191px;
        margin-top: 34px;
    }
    .index_right_padding_warn_box{
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .index_right_padding_warn{
            display: flex;
            align-items: center;
            .right_padding_warn_dec{
                
                &>div:nth-of-type(1){
                    font-size: 24px;
                    font-family: DIN-Bold, DIN;
                    font-weight: bold;
                    color: #F31C3A;
                    line-height: 24px;
                    margin-bottom: 10px;
                }
                &>div:nth-of-type(2){
                    font-size: 14px;
                    color: #9FC4E4;
                    margin-bottom: 7px;
                }
                &>div:nth-of-type(3){
                    color: #9FC4E4;
                }
            }
        }
    }
    .tableBox{
        height: 272px;
        overflow: auto;
        .businessName{
            overflow:hidden;
            text-overflow:ellipsis;
            display:-webkit-box;
            -webkit-box-orient:vertical;
            -webkit-line-clamp:2; 
        }
        /deep/ .el-table--medium .el-table__cell{
            padding: 2px 0;
        }
    }
    .numBar_box{
        position:absolute;
        top: 0;
        margin-top: 34px;
        height: calc(100% - 35px);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .numBar_box_row{
            width: 100px;
            height: 36px;
            overflow: hidden;
            position: absolute;
            &>div{
                color: #FFFFFF;
                font-size: 12px;
                &:nth-of-type(1){
                    margin-bottom: 6px;
                    margin-top: 2px;
                }
            }
        }
    }
    .numBar_box_left{
        left:calc(50% - 205px);
        .numBar_box_row{
            border-right: 2px solid transparent;
            text-align: right;
            padding-right: 8px;
            &:nth-of-type(1){
                top: 0;
                left: 30px;
            }
            &:nth-of-type(2){
                top: calc(50% - 18px);
                left: 0px;
            }
            &:nth-of-type(3){
                bottom: 0;
                left: 30px;
            }
        }
    }
    .numBar_box_right{
        left:calc(50% + 105px);
        .numBar_box_row{
            border-left: 2px solid transparent;
            text-align: left;
            padding-left: 8px;
            &:nth-of-type(1){
                top: 0;
                left: -30px;
            }
            &:nth-of-type(2){
                top: calc(50% - 18px);
                left: 0px;
            }
            &:nth-of-type(3){
                bottom: 0;
                left: -30px;
            }
        }
    }
</style>